export const slugToLabel = (label) => {
  return label
    .split('-')
    .map((word) => word[0].toUpperCase() + word.split('').splice(1, word.length).join(''))
    .join(' ')
}

export const htmlDecode = (input) => {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}

export const stringToHTML = (str) => {
  console.log(str)
  var temp = document.createElement('div')
  temp.innerHTML = '<div>' + str + '</div>'
  console.log(temp.firstChild)
  return temp.firstChild
}

export const decodeSafeEntities = (str = '') => {
  const entitySafelist = {
    amp: '&',
    '#8217': "'",
    '#8216': "'",
    '#038': '&',
    '#x27': "'",
    '#x2F': '/',
    '#39': "'",
    '#8211': '–',
    '#8230': '…',
    '#710': 'ˆ',
  }

  return str.replace(/&([^;]+);/gm, function (match, entity) {
    return entitySafelist[entity] || match
  })
}
